import React, { useContext } from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import PopupReportUsageLookupProvider, {
  PopupReportUsageLookupContext,
} from 'contextProviders/SplashScreenProviders/ContentDependantProviders/PopupReportUsageLookupProvider';
import usePopup from 'hooks/usePopup';
import Typography from 'kingpin/atoms/Typography';
import { Option } from 'kingpin/atoms/ContextMenu';
import Form from 'kingpin/forms/Form';
import FormContent from 'kingpin/forms/FormContent';
import FormHeader from 'kingpin/forms/FormHeader';
import { PopupReportUsageInfo } from 'screens/Settings/Advanced/V3Migrators/V3PopupReportsMigrator';

const PopupReportUsage = ({ report }: { report: ReportType }) => {
  const { popupReportsLookup } = useContext(PopupReportUsageLookupContext);
  const usage = popupReportsLookup[report.id];

  if (!usage || usage.length === 0) {
    return (
      <Typography.Body type="Body 12">
        This report isn't used as a popup
      </Typography.Body>
    );
  }

  return <PopupReportUsageInfo usage={usage} />;
};

// Always offered: whether the report is a popup is only worked out (by
// loading every dashboard gadget) once the modal opens
const PopupReportInfo = ({ report }: { report: ReportType }) => {
  const { isOpen, open, close } = usePopup();

  return (
    <>
      <Option
        label={'Show Popups'}
        onClick={open}
        shouldHideInsteadOfCloseMenu
      />
      <ModalTransition>
        {isOpen && (
          <Modal
            onClose={close}
            shouldScrollInViewport={false}
            autoFocus={false}
          >
            <Form>
              <FormHeader title={'Popup Report Usage'} onClose={close} />
              <FormContent>
                <PopupReportUsageLookupProvider>
                  <PopupReportUsage report={report} />
                </PopupReportUsageLookupProvider>
              </FormContent>
            </Form>
          </Modal>
        )}
      </ModalTransition>
    </>
  );
};

export default PopupReportInfo;
